import { render, staticRenderFns } from "./SettingsDefault.vue?vue&type=template&id=2716e844&scoped=true&"
import script from "./SettingsDefault.vue?vue&type=script&lang=js&"
export * from "./SettingsDefault.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDefault.vue?vue&type=style&index=0&id=2716e844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716e844",
  null
  
)

export default component.exports